<template>
  <div id="coinPurse">
    <mt-header fixed :title="display_coin_symbol" style="height: 40px">
      <mt-button icon="back" slot="left" @click.native="back()"></mt-button>
    </mt-header>
    <div class="header" :class="[this.$route.query.category !== 'HD' ? '' : 's2']">
      <div class="role_info" v-if="detailCata.chain_game_id > 0">
        <p class="r_i_left">
          <span>{{ $t("角色信息") }} : </span>
          <span class="" v-if="detailCata.chain_game_role_info">{{ detailCata.chain_game_role_info.server_name }} -
            {{ detailCata.chain_game_role_info.role_name }}</span>
          <span v-else>{{ $t("未绑定") }}</span>
        </p>
        <p class="r_i_right" v-if="!detailCata.chain_game_role_info">
          <mt-button type="primary" size="small" class="add_role" @click="showAdd(detailCata.coin_id)">
            {{ $t("立即绑定") }}
          </mt-button>
        </p>
      </div>

      <!-- 云端钱包 -->
      <template v-if="$route.query.category !== 'HD'">
        <!-- <p class="amount wx_fontSize5" v-if="detailCata.chain_game_id > 0">
          <span class="label">{{ $t("总资产") }}</span>
          <span v-if="detailCata.chain_game_role_info">{{
            roleBalance | numFilter
          }}</span>
          <span v-else>0</span>
        </p> -->
        <p class="amount wx_fontSize5">
          <span class="label">{{ $t("总资产") }}</span>
          <!-- <span v-if="detailCata.chain_game_role_info.length">{{
            price | numFilter
          }}</span>
          <span v-else>0</span> -->
          <span>{{ parseFloat(detailCata.cloud_balance) | toThousandFilter }}</span>
        </p>
      </template>
      <template v-else>
        <p class="amount wx_fontSize5">
          <span class="label">{{ $t("总资产") }}</span>
          <span>{{ hd_balance | numFilter | toThousandFilter }}</span>
        </p>
      </template>
      <div class="asset" v-if="this.$route.query.category !== 'HD'">
        <p class="asset-item-left">
          <span class="label">{{ $t("可用资产") }}</span>
          <span class="value">{{ parseFloat(detailCata.cloud_balance) | toThousandFilter }}</span>
        </p>
        <p class="asset-item-right">
          <span class="label">
            {{ $t("锁定资产")}}
            <!-- <img
              class="locked-i"
              src="../../assets/img/lockedI.png"
              alt=""
              @click="showLockedInfo"
            /> -->
          </span>
          <span class="value">{{ (detailCata.locked_balance || 0.00) | toThousandFilter }}</span>
        </p>
      </div>
      <ul class="select wx_fontSize3" v-if="this.$route.query.category == '云端'">
        <li @click="send()" :class="this.detailCata.exchange_state == 1
            ? 'select_active'
            : 'select_isactive'
          ">
          <img src="../../assets/img/zhuanzhang.png" alt="" />
          <span>{{ $t("发送") }}</span>
        </li>
        <li style="border: 0" @click="receive()" :class="this.detailCata.exchange_state == 1
            ? 'select_active'
            : 'select_isactive'
          ">
          <img src="../../assets/img/shoukuan.png" alt="" />
          <span>{{ $t("接收") }}</span>
        </li>
        <li @click="against()" v-if="this.detailCata.exchange_state == 1">
          <img src="../../assets/img/shandui.png" alt="" />
          <span>{{ $t("闪兑") }}</span>
        </li>
      </ul>
      <ul class="select wx_fontSize3" v-else>
        <li @click="send()" style="width: 49%">
          <img src="../../assets/img/zhuanzhang.png" alt="" /><br />
          <span>{{ $t("发送") }}</span>
        </li>
        <li style="border: 0; width: 49%" @click="receive()">
          <img src="../../assets/img/shoukuan.png" alt="" /><br />
          <span>{{ $t("接收") }}</span>
        </li>
      </ul>
    </div>

    <div class="content" ref="content_detail">
      <p class="title wx_fontSize2">{{ $t("交易记录") }}</p>
      <div class="page-loadmore-wrapper" ref="wrapper" :style="{ height: wrapperHeight + 'px' }">
        <mt-loadmore :top-method="loadTop" @top-status-change="handleTopChange" :bottom-method="loadBottom"
          @bottom-status-change="handleBottomChange" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
          <ul v-if="$route.query.category == '云端'" class="content_detail">
            <li @click="
              coinDetail(
                display_coin_symbol,
                item.log_time,
                item.transfer_status_msg,
                item.amount,
                item.fee,
                item.from_address,
                item.to_address,
                item.tx_id,
                item.type,
                item.memo
              )
              " v-for="(item, index) in transactionsList" :key="index">
              <img v-bind:src="sendPay" alt="" class="oImg" v-if="item.amount < 0" />
              <img v-bind:src="resivePay" alt="" class="oImg" v-else />
              <span class="currency_name">
                <!-- <span class="receive wx_fontSize3">{{item.type ==1 ? $t("云端转出") :(item.type ==2 ? $t("云端充值"):(item.type == 3?$t("闪兑"):(item.type==4?$t("理财产品"):(item.type==7?$t("HD转出"):(item.type==8?$t("HD转入"):(item.type == 9?$t("发送红包"):(item.type ==10?$t("领取红包"):"")))))))}}</span> -->
                <span class="receive wx_fontSize3">{{ item.type_msg }}</span>
                <span class="form wx_fontSize2">{{ item.from_address }}</span>
              </span>
              <div class="amount_of wx_rt">
                <p class="count wx_fontSize3">
                  {{ item.amount | numFilter | toThousandFilter }}{{ display_coin_symbol }}
                </p>
                <p class="money wx_fontSize2">
                  {{ item.log_time | parseTime("{y}-{m}-{d} {h}:{i}") }}
                </p>
              </div>
            </li>
          </ul>
          <ul v-else class="content_detail">
            <li v-for="(item, index) in transactionsListHD" :key="index" class="s2">
              <img v-bind:src="sendPay" alt="" class="oImg" v-if="item.amount < 0" />
              <img v-bind:src="resivePay" alt="" class="oImg" v-else />
              <span class="currency_name">
                <!-- <span class="receive wx_fontSize3">{{item.type ==1 ? $t("云端转出") :(item.type ==2 ? $t("云端充值"):(item.type == 3?$t("闪兑"):(item.type==4?$t("理财产品"):(item.type==7?$t("HD转出"):(item.type==8?$t("HD转入"):(item.type == 9?$t("发送红包"):(item.type ==10?$t("领取红包"):"")))))))}}</span> -->
                <span class="receive wx_fontSize3">{{
                  item.transactionType == 1 ? $t("转出") : $t("转入")
                }}</span>
                <span class="form wx_fontSize">{{
                  item.transactionType == 1 ? item.toAddress : item.fromAddress
                }}</span>
              </span>
              <div class="amount_of wx_rt">
                <p class="count wx_fontSize3">
                  {{ item.amount | numFilter | toThousandFilter }}{{ item.coinSymbol }}
                </p>
                <!-- <p class="money wx_fontSize2">{{ item.log_time | parseTime('{y}-{m}-{d} {h}:{i}') }}</p> -->
              </div>
            </li>
          </ul>
          <div slot="top" class="mint-loadmore-top">
            <span v-show="topStatus !== 'loading'" :class="{ 'is-rotate': topStatus === 'drop' }">↓</span>
            <span v-show="topStatus === 'loading'">
              <mt-spinner type="snake"></mt-spinner>{{ $t("正在刷新...") }}
            </span>
          </div>
          <div slot="bottom" class="mint-loadmore-bottom">
            <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }"></span>
            <span v-show="bottomStatus === 'loading'">
              <mt-spinner type="snake"></mt-spinner>{{ $t("正在加载...") }}
            </span>
          </div>
        </mt-loadmore>
      </div>
    </div>
    <div class="block_list" ref="block_list">
      <img src="../../assets/img/coinDetail/img_wujilu.png" alt="" />
      <p class="tip wx_fontSize3">{{ $t("暂无相关记录") }}</p>
    </div>
  </div>
</template>

<script>
import {
  httpTransactions,
  httpAccountInfo,
  httpAccountTransactions,
  httpAccountHDInfo,
} from "@/api/index";
import { httpCoinBalance, httpCoinRecord } from "@/api/hdwallet";
import { formatTime } from "@/utils/index";
import { numFilter } from "@/filters/index";
import handleClipboard from "@/utils/clipboard";
import { Toast } from "mint-ui";
import { MessageBox } from "mint-ui";
import { httpPostRoleBalance } from "@/api/game"; //链游角色余额

export default {
  data() {
    return {
      title: "",
      coin_symbol: "",
      display_coin_symbol: "",
      transactionsList: [],
      transactionsListHD: [],
      pageNo: 1,
      array_pages: "",
      allLoaded: false,
      bottomStatus: "",
      wrapperHeight: 0,
      topStatus: "",
      translate: 0,
      moveTranslate: 0,
      price: "",
      img_url: "",
      address: "",
      detailCata: {},
      currency_char: "",
      currency_usd_rate: "",
      resivePay: require("@/assets/img/icon-zhuanru.png"),
      sendPay: require("@/assets/img/icon-zhuanchu.png"),
      popupVisible: false,
      popup_add_role: false,
      roleBalance: 0,
      serverList: [],
      hd_balance: 0,
      showload: true,
    };
  },
  mounted() {
    this.wrapperHeight =
      document.documentElement.clientHeight -
      this.$refs.wrapper.getBoundingClientRect().top;
  },
  activated() {
    this.title = this.$route.query.title;
    this.symbol_id = this.$route.query.id;
    this.coin_symbol = this.$route.query.display_coin_symbol;
    this.display_coin_symbol = this.$route.query.display_coin_symbol;
    this.price = this.$route.query.price;
    this.img_url = this.$route.query.img_url;
    this.info();
    this.transactions(1);
    this.showload = true;
  },
  methods: {
    back() {
      this.$router.back();
      if (!this.detailCata.chain_game_role_info) {
        this.detailCata = {};
      }
    },
    copy: function (event, val) {
      handleClipboard(
        val,
        event,
        () => {
          Toast(this.$t("fuzhicg"));
        },
        () => {
          Toast(this.$t("fuzhicc"));
        }
      );
    },
    send() {
      this.price = this.detailCata.price;
      this.$router.push({
        path: "/send-network",
        query: {
          coin_symbol: this.title,
          price: this.price,
          category: this.$route.query.category,
          display_coin_symbol: this.display_coin_symbol,
          symbolId: this.symbol_id,
        },
      });
      window.LS.set(
        "withdraw_network",
        JSON.stringify(this.detailCata.withdraw_network_list)
      );
    },
    against() {
      this.$router.push({
        path: "/against",
        query: {
          coin_symbol: this.title,
          price: this.price,
          img_url: this.img_url,
          display_coin_symbol: this.display_coin_symbol,
        },
      });
    },
    receive() {
      this.$router.push({
        path: "/receive-network",
        query: {
          coin_symbol: this.title,
          category: this.$route.query.category,
          display_coin_symbol: this.display_coin_symbol,
          symbolId: this.symbol_id,
        },
      });
    },
    coinDetail(
      title,
      log_time,
      transfer_status_msg,
      amount,
      fee,
      from_address,
      to_address,
      tx_id,
      type,
      memo
    ) {
      this.$router.push({
        path: "/coinDetail",
        query: {
          title: title,
          log_time: log_time,
          transfer_status_msg: transfer_status_msg,
          amount: amount,
          fee: fee,
          from_address: from_address,
          to_address: to_address,
          tx_id: tx_id,
          type: type,
          memo: memo,
        },
      });
      // console.log(title);
    },
    handleBottomChange(status) {
      this.bottomStatus = status;
    },
    loadBottom() {
      var _this = this;
      setTimeout(() => {
        if (_this.pageNo * 10 <= _this.array_pages) {
          _this.pageNo++;
          _this.transactions(_this.pageNo);
        } else {
          _this.allLoaded = true;
        }
        _this.$refs.loadmore.onBottomLoaded();
      }, 1500);
    },

    handleTopChange(status) {
      this.moveTranslate = 1;
      this.topStatus = status;
    },

    translateChange(translate) {
      const translateNum = +translate;
      this.translate = translateNum.toFixed(2);
      this.moveTranslate = (1 + translateNum / 70).toFixed(2);
    },

    loadTop() {
      var _this = this;
      setTimeout(() => {
        _this.transactions(1);
        _this.allLoaded = false;
        _this.pageNo = 1;
        _this.$refs.loadmore.onTopLoaded();
      }, 1500);
    },
    transactions(pageNo) {
      if (this.$route.query.category == "云端") {
        httpTransactions({
          coin_symbol: this.title,
          limit_begin: 0,
          limit_end: pageNo * 10,
        })
          .then((res) => {
            this.transactionsList = [];
            this.transactionsList = res.data.list;
            this.array_pages = res.data.count;
            if (this.transactionsList.length == 0) {
              this.$refs.content_detail.style.display = "none";
              this.$refs.block_list.style.display = "block";
            } else {
              this.$refs.content_detail.style.display = "block";
              this.$refs.block_list.style.display = "none";
            }
          })
          .catch(() => { });
      } else if (this.$route.query.category == "HD") {
        httpCoinRecord({ symbolId: this.symbol_id, pageNo: 0, pageSize: 10000 })
          .then(({ result }) => {
            this.transactionsListHD = [];
            this.transactionsListHD = result.records;
            // this.array_pages = res.data.count;
            if (this.transactionsListHD.length == 0) {
              this.$refs.content_detail.style.display = "none";
              this.$refs.block_list.style.display = "block";
            } else {
              this.$refs.content_detail.style.display = "block";
              this.$refs.block_list.style.display = "none";
            }
          })
          .catch(() => { });
      }
    },
    info() {
      if (this.$route.query.category == "云端") {
        httpAccountInfo({
          coin_symbol: this.title,
          currency: this.$store.getters.currency,
        })
          .then((res) => {
            this.address = res.data.address;
            this.detailCata = res.data;
            this.showload = false;
            if (res.data.chain_game_id > 0 && res.data.chain_game_role_info) {
              this.getRoleBalance({ coin_id: this.detailCata.coin_id });
            }
          })
          .catch(() => { });
      } else if (this.$route.query.category == "HD") {
        httpCoinBalance({ symbolId: this.$route.query.id }).then(
          ({ result }) => {
            this.hd_balance = result.balance;
          }
        );
        /* httpAccountHDInfo({ coin_symbol: this.coin_symbol, currency: this.$store.getters.currency })
          .then(res => {
            this.address = res.data.address;
            this.detailCata = res.data;
            if (res.data.chain_game_id > 0 && res.data.chain_game_role_info) {
              this.getRoleBalance({ coin_id: this.detailCata.coin_id })
            }
          })
          .catch(() => { }); */
      }
    },
    showLockedInfo() {
      MessageBox({
        title: this.$t("提示"),
        message: this.$t("锁仓截止日期") + " : 2023/7/25",
        confirmButtonText: this.$t("确定"),
      });
    },
    getRoleBalance(coin_id) {
      httpPostRoleBalance(coin_id)
        .then((res) => {
          this.roleBalance = res.data.balance;
        })
        .catch(() => { });
    },
    showAdd(coin_id) {
      this.$router.push({ path: "/bind_role", query: { coin_id: coin_id } });
    },
  },
};
</script>
<style scoped>
.mint-header {
  background: #fff;
  color: #000;
}

.header {
  width: 100%;
  height: 330px;
  position: relative;
  margin-top: 40px;
  background: #f5f5f5;
}

.header.s2 {
  height: auto;
  padding-bottom: 20px;
}

.header.s2 .select {
  position: static;
}

.header .bg {
  width: 100%;
  height: 100%;
}

.amount {
  color: #1c74f2;
  padding: 30px 15px 40px;
  font-weight: 700;
  font-size: 33px;
  text-align: center;
}

.asset {
  overflow: hidden;
  margin-bottom: 35px;
  display: flex;
}

.asset-item-left {
  flex-grow: 1;
  padding: 0 20px;
  border-right: solid 1px #dddddd;
}

.asset-item-right {
  padding: 0 20px;
  flex-grow: 1;
}

.asset-item-left .label,
.asset-item-right .label,
.amount .label {
  width: 100%;
  color: #666666;
  font-size: 12px;
  padding-bottom: 10px;
  display: block;
  text-align: center;
  font-weight: 400;
}

.asset-item-left .value,
.asset-item-right .value {
  color: #333333;
  font-size: 15px;
  text-align: center;
  display: block;
}

.select {
  position: absolute;
  bottom: 23px;
  height: 70px;
  width: calc(100% - 30px);
  background: #fff;
  color: #333333;
  border-radius: 10px;
  margin: 0 15px;
  display: flex;
}

.select li {
  flex-grow: 1;
  height: 30px;
  margin-top: 13px;
  float: left;
  text-align: center;
  line-height: 30px;
}

.select li img {
  width: 18px;
}

.select li span {
  display: block;
  margin-top: -5px;
  font-size: 12px;
  color: #333333;
}

/*内容*/
.content {
  width: 100%;
}

.title {
  color: #8c92a8;
  padding: 16px 15px 0 15px;
}

.content_detail {
  position: relative;
  padding: 0 15px;
}

.content_detail li {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #e3e8ed;
  font-weight: 500;
}

.oImg {
  width: 48px;
  height: 48px;
  margin: 10px 14px 9px 0px;
}

.currency_name {
  position: relative;
  display: inline-block;
  width: 40%;
  height: 65px;
}

.receive {
  position: absolute;
  top: 10px;
}

.form {
  position: absolute;
  bottom: 5px;
  color: #8c92a8;
  height: 20px;
  width: 100%;
  overflow: hidden;
}

.amount_of {
  width: 36%;
  height: 100%;
  text-align: right;
}

.count {
  color: #212529;
  font-weight: bold;
  margin-top: 10px !important;
  font-weight: 500;
}

.money {
  color: #8c92a8;
  margin-top: 10px;
}

.block_list {
  width: 100%;
  display: none;
}

.block_list img {
  margin-top: 62px;
  width: 264px;
  margin-left: calc(50% - 132px);
}

.tip {
  color: #8c92a8;
  width: 100%;
  text-align: center;
  position: relative;
  top: -40px;
}

.mint-loadmore {
  overflow: visible;
}

.locked-i {
  width: 15px;
  height: 15px;
  position: relative;
  top: 3px;
}

/deep/ .mint-msgbox {
  width: 50%;
}

.mint-popup {
  padding: 20px;
}

.mint-popup span {
  display: block;
}

.add_role {
  font-size: 12px;
  height: 24px;
  background: none;
  color: #1c74f2;
  /*padding: 0 5px;*/
}

.role_info {
  /*margin-top: 40px;*/
  overflow: hidden;
  padding: 10px 15px;
  color: #8a8ca5;
  font-size: 14px;
  background: #eaeaea;
}

.role_info .r_i_left {
  float: left;
  padding-top: 2px;
}

.role_info .r_i_right {
  float: right;
}

.role_i {
  padding-top: 3px;
}

.content_detail li.s2 {
  position: relative;
  display: flex;
  align-items: center;
}

.content_detail li.s2 .amount_of {
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
}

.content_detail li.s2 .currency_name {
  flex: 1;
}

.wx_fontSize {
  font-size: 12px;
}
</style>
